

<section class="h-full flex flex-col gap-2 z-0 relative overflow-y-auto  p-2 lg:pl-0">
<div class="max-w-6xl p-4 rounded-lg bg-white dark:bg-zinc-950 border" [ngClass]="{
            'shadow-lg border border-zinc-950/10 dark:border-white/10': source !== 'modal'
          }">
    <form [formGroup]="addonsForm" (ngSubmit)="onSave()">
        <h1 *ngIf="source !== 'modal'" class="heading">
            {{addonId ? 'Edit' : 'Add'}}
        </h1>
        <hr *ngIf="source !== 'modal'" class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        
        <section class="grid gap-4 md:grid-cols-2">

            <!-- name -->
            <div class="space-y-1">
                <label class="subheading">
                    Title <span class="text-red-600">*</span>
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <input type="text" formControlName="title" />
                    </div>
                </div>
                <div *ngIf="form.title.errors && submitted">
                    <div *ngIf="form.title.errors.required" class="error">
                        <p class="mt-2 text-red-600 text-xs">
                            Title is required
                        </p>
                    </div>
                </div>
            </div> 

            <!--Code-->
            <div class="space-y-1">
                <label class="subheading">
                    Code <span class="text-red-600">*</span>
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <input type="text" formControlName="code" />
                    </div>
                </div>
                <div *ngIf="form.code.errors && submitted">
                    <div *ngIf="form.code.errors.required" class="error">
                        <p class="mt-2 text-red-600 text-xs">
                            Code is required
                        </p>
                    </div>
                </div>
            </div>

            <!--Fare-->

            <div class="space-y-1">
                <label class="subheading">
                    Rate <span class="text-red-600">*</span>
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <input type="text" formControlName="fare" />
                    </div>
                </div>
                <div *ngIf="form.fare.errors && submitted">
                    <div *ngIf="form.fare.errors.required" class="error">
                        <p class="mt-2 text-red-600 text-xs">
                            Rate is required
                        </p>
                    </div>
                </div>
            </div>

            <!-- Type -->
            <div class="space-y-1">
                <label class="subheading">
                    Type
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <select formControlName="type">
                            <option [value]="'fixed'">Fixed</option>
                            <option [value]="'percentage'">Percentage</option>
                          </select>
                    </div>
                </div>
            </div>
            <!-- status -->
            <div class="space-y-1">
                <label class="subheading">
                    Status
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <select formControlName="isActive">
                            <option [value]="true">Active</option>
                            <option [value]="false">Inactive</option>
                          </select>
                    </div>
                </div>
            </div>

            <!-- Description -->
            <div class="col-span-full space-y-1">
                <label class="subheading">
                    Description <span class="text-red-600">*</span>
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <textarea formControlName="description" class="h-16"></textarea>
                    </div>
                </div>
                <div *ngIf="form.description.errors && submitted">
                    <div *ngIf="form.description.errors.required" class="error">
                        <p class="mt-2 text-red-600 text-xs">
                            Description is required
                        </p>
                    </div>
                </div>
            </div>


        </section>
        <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        
        <section class="flex flex-wrap gap-4 ">
            <div class="flex items-center justify-center border border-dashed border-zinc-950/10 dark:border-white/10 p-1.5 rounded-lg gap-2.5">
                <label class="subheading">Private Only</label>
                <div class="flex">
                    <label
                        class="relative inline-flex h-6 w-12 flex-shrink-0 cursor-pointer rounded-full border-zinc-950/10 dark:border-white/10 bg-zinc-950/5 dark:bg-white/5 text-sm-dark transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                        <input type="checkbox" formControlName="isPrivateOnly" class="peer sr-only"
                            (change)="togglePrivateOnly($event)" aria-checked="addonsForm.get('isPrivateOnly')?.value" />
                        <span
                            class="pointer-events-none relative inline-block h-6 w-6 transform rounded-full bg-white shadow ring-0 transition-all duration-200 ease-in-out peer-checked:translate-x-6 peer-checked:bg-green-500">
                            <span *ngIf="!addonsForm.get('isPrivateOnly')?.value"
                                class="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-100 peer-checked:opacity-0"
                                aria-hidden="true">
                                <svg class="h-3 w-3 text-red-500" fill="none" viewBox="0 0 12 12">
                                    <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </span>
                            <span *ngIf="addonsForm.get('isPrivateOnly')?.value"
                                class="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-100 peer-checked:opacity-100"
                                aria-hidden="true">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                    stroke="currentColor" class="h-3 w-3 text-white">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                                </svg>
                            </span>
                        </span>
                    </label>
                </div>
            </div>
            <div class="flex items-center justify-center border border-dashed border-zinc-950/10 dark:border-white/10 p-1.5 rounded-lg gap-2.5">
                <label class="subheading">Discount</label>
                <div class="flex">
                    <label
                        class="relative inline-flex h-6 w-12 flex-shrink-0 cursor-pointer rounded-full border-zinc-950/10 dark:border-white/10 bg-zinc-950/5 dark:bg-white/5 text-sm-dark transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                        <input type="checkbox" formControlName="isDiscount" class="peer sr-only"
                            (change)="toggleDiscount($event)" aria-checked="addonsForm.get('isDiscount')?.value" />
                        <span
                            class="pointer-events-none relative inline-block h-6 w-6 transform rounded-full bg-white shadow ring-0 transition-all duration-200 ease-in-out peer-checked:translate-x-6 peer-checked:bg-green-500">
                            <span *ngIf="!addonsForm.get('isDiscount')?.value"
                                class="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-100 peer-checked:opacity-0"
                                aria-hidden="true">
                                <svg class="h-3 w-3 text-red-500" fill="none" viewBox="0 0 12 12">
                                    <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </span>
                            <span *ngIf="addonsForm.get('isDiscount')?.value"
                                class="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-100 peer-checked:opacity-100"
                                aria-hidden="true">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                    stroke="currentColor" class="h-3 w-3 text-white">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                                </svg>
                            </span>
                        </span>
                    </label>
                </div>
            </div>
            <div class="flex items-center justify-center border border-dashed border-zinc-950/10 dark:border-white/10 p-1.5 rounded-lg gap-2.5">
                <label class="subheading">Credit Card Fee</label>
                <div class="flex">
                    <label
                        class="relative inline-flex h-6 w-12 flex-shrink-0 cursor-pointer rounded-full border-zinc-950/10 dark:border-white/10 bg-zinc-950/5 dark:bg-white/5 text-sm-dark transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                        <input type="checkbox" formControlName="isCreditCardFee" class="peer sr-only"
                            (change)="toggleCreditCardFee($event)" aria-checked="addonsForm.get('isCreditCardFee')?.value" />
                        <span
                            class="pointer-events-none relative inline-block h-6 w-6 transform rounded-full bg-white shadow ring-0 transition-all duration-200 ease-in-out peer-checked:translate-x-6 peer-checked:bg-green-500">
                            <span *ngIf="!addonsForm.get('isCreditCardFee')?.value"
                                class="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-100 peer-checked:opacity-0"
                                aria-hidden="true">
                                <svg class="h-3 w-3 text-red-500" fill="none" viewBox="0 0 12 12">
                                    <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </span>
                            <span *ngIf="addonsForm.get('isCreditCardFee')?.value"
                                class="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-100 peer-checked:opacity-100"
                                aria-hidden="true">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                    stroke="currentColor" class="h-3 w-3 text-white">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                                </svg>
                            </span>
                        </span>
                    </label>
                </div>
            </div>
        </section>
        <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <section class="flex justify-end gap-4">            
            <button type="submit" class="btn btn-secondary">
                {{addonId ? 'Update' : 'Create'}}
            </button>
        </section>
    </form>
</div>
</section>